<template>
  <div class="page-wrapper start-layout">
    <div class="page-inner">
      <div class="page-content-wrapper bg-transparent m-0">
        <start-header />

        <start-body />

        <app-footer />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppFooter from '@/components/appLayout/Footer';
import StartBody from '@/components/startLayout/Body';
import StartHeader from '@/components/startLayout/Header';

// @vuese
// Layout aplikacji dla niezalogowanego użytkownika
// @group Layouts
export default {
  components: { AppFooter, StartHeader, StartBody },

  computed: mapState({ appTitle: state => state.system.appTitle }),

  created() {
    document.title = this.appTitle;
  }
};
</script>
